import React from 'react'
import PropTypes from 'prop-types'

const Label = (props) => {
  const { title, className, children } = props
  return (
    <div className={className} title={title}>
      {children}
    </div>
  )
}

Label.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

Label.defaultProps = {
  title: '',
  className: ''
}

export default Label
